import React from 'react';
import { isPresentInArray } from '../../../../../itrust_common/components/HelperFunctions';
import DisplayField from '../../../../../itrust_common/components/others/DisplayField'
import OldValuesHeader from '../../oldValues/OldValuesHeader';

let Impression = props => {
  const { fieldsValues, selectedIds, handleIdsSelect, overviewName, previousExams, fieldKey, examId } = props;

  const renderTable = (values) => (
    <div className="col-12 pt-4">
      <div className="overview-table">
        <table className="table bg-light table-hover shadow-none border border-muted">
          <thead className="text-dark border border-muted">
            <tr className="text-center">
              <th scope="col"><DisplayField isVisible={true} label={"No."} /></th>
              <th scope="col"><DisplayField isVisible={true} label={"Impression"} /></th>
              <th scope="col"><DisplayField isVisible={true} label={"Code"} /></th>
              <th scope="col"><DisplayField isVisible={true} label={"Plan"} /></th>
              {overviewName && <th scope="col"><DisplayField isVisible={true} label={"Select"} /></th>}
            </tr>
          </thead>
          <tbody>
            {values?.map((impression, index) =>
              <tr className="text-center" key={impression.id || index}>
                <td><DisplayField isVisible={true} value={String.fromCharCode(index + 97).toUpperCase()} /></td>
                <td><DisplayField isVisible={true} value={impression.impression && impression.impression.name} /></td>
                <td><DisplayField isVisible={true} value={impression.impression && impression.impression.code} /></td>
                <td><DisplayField isVisible={true} value={impression.associated_plans_attributes?.map(plan => plan.name).join(', ')} /></td>
                {overviewName && <td>
                  <div className="custom-control custom-checkbox">
                    <input
                      onChange={() => handleIdsSelect(selectedIds, impression.id)}
                      type="checkbox"
                      checked={isPresentInArray(selectedIds, impression.id)}
                      className="custom-control-input" id={`impression-select-${impression.id}`} />
                    <label className="custom-control-label" htmlFor={`impression-select-${impression.id}`}></label>
                  </div>
                </td>}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <>
      {fieldsValues && <div className="row w-100">{renderTable(fieldsValues)}</div>}
      {previousExams?.filter(item => item.id !== examId).map(prevExam => {
        const values = prevExam?.[fieldKey];
        if (!values?.length) return null;

        return (
          <div className="col-12 border rounded mb-4 px-0" key={prevExam.id}>
            <div className="row mx-0">
              <OldValuesHeader
                prevExam={prevExam}
                overviewName={overviewName}
                examId={examId}
                importIds={values.map(item => item.id).filter(Boolean)}
              />
              {renderTable(values)}
            </div>
          </div>
        );
      })}
    </>
  )
}


export default Impression;
